import React from "react";
import "./AboutInnovationForAll.css";

// Import Font Awesome icons
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGraduationCap,
  faHome,
  faTractor,
  faMicrochip,
  faTools,
  faFlask,
  faRocket,
  faStore,
  faIndustry,
  faUserCog,
  faPaintBrush,
  faLightbulb,
  faLeaf,
  faUsers
} from '@fortawesome/free-solid-svg-icons';

// Add icons to library
library.add(
  faGraduationCap,
  faHome,
  faTractor,
  faMicrochip,
  faTools,
  faFlask,
  faRocket,
  faStore,
  faIndustry,
  faUserCog,
  faPaintBrush,
  faLightbulb,
  faLeaf,
  faUsers
);

const InnovateSection = () => {
  const gridItems = [
    { icon: faGraduationCap, label: "Students" },
    { icon: faHome, label: "Housewives" },
    { icon: faTractor, label: "Farmers" },
    { icon: faMicrochip, label: "Engineers" },
    { icon: faTools, label: "Technicians" },
    { icon: faFlask, label: "Researchers" },
    { icon: faRocket, label: "Entrepreneurs" },
    { icon: faStore, label: "Startups" },
    { icon: faIndustry, label: "MSMEs" },
    { icon: faUserCog, label: "Industrial Pros" },
    { icon: faPaintBrush, label: "Designers" },
    { icon: faLightbulb, label: "Inventors" },
    { icon: faLeaf, label: "Rural Innovators" },
    { icon: faUsers, label: "Senior Citizens" },
  ];

  return (
    <div className="innovate-wrapper">
      <div className="innovate-container">
        {/* LEFT CONTENT */}
        <div className="left-content">
          <h2 className="title">Who Can Innovate</h2>
          <p className="subhead">
            Innovation Has No Age. No Profession. No Boundary.
          </p>
          <p className="description">
            The next great innovation may not come from a laboratory. It may come
            from a kitchen. A farm. A workshop. A classroom. A factory. Or from
            someone who simply asked, <br />
            <span className="quote">"Why can't this be done better?"</span>
          </p>
          <p className="story">
            A housewife who struggles with a daily family problem may have the
            idea for a product that millions of families need. APIC ProtoHub aims
            to give that idea a pathway.
          </p>
          <div className="pathway-steps">
            <span>Idea</span>
            <span className="arrow">→</span>
            <span>Prototype</span>
            <span className="arrow">→</span>
            <span>Patent</span>
            <span className="arrow">→</span>
            <span>Product</span>
            <span className="arrow">→</span>
            <span>Market</span>
          </div>
        </div>

        {/* RIGHT GRID */}
        <div className="right-grid">
          {gridItems.map((item, index) => (
            <div className="grid-box" key={index}>
              <div className="box-icon">
                <FontAwesomeIcon icon={item.icon} />
              </div>
              <div className="box-label">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InnovateSection;